import { MEAL_PLANNER_SLOTS, plannerSlotSummaries } from '@/helper/dashboardStatus';
import { linesForChildAndDate, mealDateIso } from '@/helper/cartFamily';

/**
 * When opening Menu from Home "Add more meals", prefer a slot with no paid/cart lines.
 */
export function pickMenuServingTimeId({ servingTimes, cartLines, servingTimeSlots }) {
	const dateLines = cartLines || [];
	const slots = plannerSlotSummaries(servingTimes, dateLines);
	const slotOrder = MEAL_PLANNER_SLOTS;

	for (const name of slotOrder) {
		const slot = slots.find((s) => s.name === name);
		if (!slot) continue;
		if (slot.paidQty > 0 || slot.cartQty > 0) continue;
		const st = (servingTimeSlots || []).find(
			(s) => String(s.name).toLowerCase() === name.toLowerCase()
		);
		if (st?.id != null) return Number(st.id);
	}

	for (const name of slotOrder) {
		const slot = slots.find((s) => s.name === name);
		if (slot && slot.cartQty === 0) {
			const st = (servingTimeSlots || []).find(
				(s) => String(s.name).toLowerCase() === name.toLowerCase()
			);
			if (st?.id != null) return Number(st.id);
		}
	}

	const first = (servingTimeSlots || []).find((s) => s?.id && String(s.name).toLowerCase() !== 'void');
	return first ? Number(first.id) : null;
}

export function pickMenuServingTimeForChild({
	childDashboardServingTimes,
	cartItems,
	childId,
	mealDate,
	servingTimeSlots,
}) {
	const dateIso = mealDateIso(mealDate);
	const lines = linesForChildAndDate(cartItems, childId, dateIso);
	return pickMenuServingTimeId({
		servingTimes: childDashboardServingTimes,
		cartLines: lines,
		servingTimeSlots,
	});
}
